module.exports = __webpack_public_path__ + "img/Yang_Yang@2x.6124ab3d.png";